import axios from "axios";
import baseUrls from "../../../config/service";
import { GetDigitalKycDataResponse } from "./models/GetDigitalKycDataResponse";
import { ValidateDkycRequestResponse } from "./models/ValidateDkycRequestResponse";
 

export function validateDkycRequestId(requestId: string) {
  return new Promise<ValidateDkycRequestResponse>((resolve, reject) => {

  const baseURL = baseUrls.nbfcKYC + "/video-kyc/digital-kyc/request/"+requestId;
    
    axios.get(baseURL).then((response) => {

      if (response.data.Code === 0 && response.data.Errors.length === 0) {
        resolve(response.data.PayLoad);
      } else {
        reject(response.data.Errors[0].Message || "Failed to Validate the Request");
      }
    }); 
  });
}

export function getAccessTokenForDkyc(requestId: string) {
  return new Promise<string>((resolve, reject) => {
  const baseURL = baseUrls.nbfcKYC + "/video-kyc/auth/token";
  axios.post(baseURL, {RequestId : requestId}).then((response) => {

    if (response.data.Code === 0 && response.data.Errors.length === 0) {
      resolve(response.data.PayLoad);
    } else {
      reject(response.data.Errors[0].Message);
    }
  });
});
}

export function getDigitalKycData(requestId: string) {
  return new Promise<GetDigitalKycDataResponse>((resolve, reject) => {
  const baseURL = baseUrls.nbfcKYC + "/video-kyc/digital-kyc/data/" +requestId;
  axios.get(baseURL).then((response) => {

    if (response.data.Code === 0 && response.data.Errors.length === 0) {
      resolve(response.data.PayLoad);
    } else {
      reject(response.data.Errors[0].Message);
    }
  });
});
}

